import React, { useEffect, useRef } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import styles from './GuidedTourOverlay.module.css';

// Tempo para ler o encerramento antes de ir sozinho para o Início
const FAREWELL_MS = 7000;

/**
 * Encerramento do guia, dentro da janela do último passo concluído: diz que está
 * tudo pronto e leva para o Início sozinho (a barra mostra o tempo), ou na hora
 * pelo botão.
 * @param {Function} onGo - encerra o guia e abre o Início
 */
function GuidedTourFarewell({ onGo }) {
  const goRef = useRef(onGo);
  goRef.current = onGo;

  useEffect(() => {
    const timer = setTimeout(() => goRef.current(), FAREWELL_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className={styles.nextBox}>
        <span className={styles.nextLabel}>Primeiros passos concluídos</span>
        <strong>Ótimo, agora é só aproveitar!</strong>
        <span className={styles.nextText}>
          A Gabriela já está trabalhando por você. Vou te levar para o Início...
        </span>
        <span className={styles.farewellBar} aria-hidden="true">
          <span style={{ animationDuration: `${FAREWELL_MS}ms` }} />
        </span>
      </div>
      <div className={styles.celebrateActions}>
        <button type="button" className={styles.primaryButton} onClick={onGo}>
          Ir para o Início <ArrowForwardIcon fontSize="small" />
        </button>
      </div>
    </>
  );
}

export default GuidedTourFarewell;
